import Accordion from '@components/V4/Accordion';
import { Enrollment } from '@shared/clientTypes';
import moment from 'moment';
import SurveyDetail from './SurveyDetail';

interface SurveyAccordionProps {
  enrollment: Enrollment;
  defaultIsAccordionOpen: boolean;
}

const SurveyAccordion = ({ enrollment, defaultIsAccordionOpen }: SurveyAccordionProps) => {
  const { survey: surveys } = enrollment;
  if (!surveys || surveys.length === 0) {
    return <p className="text-xs text-customGrey italic">No surveys available.</p>;
  }

  return (
    <div className="flex flex-col gap-4">
      {surveys.map((survey, index) => (
        <Accordion
          key={index}
          defaultIsOpen={defaultIsAccordionOpen}
          title={
            <p className="font-raleway font-medium text-xs text-white">
              {survey.type.toLocaleUpperCase() || 'Survey'}
            </p>
          }
          titleWrapperClassName="bg-surfaceHover p-2"
          className="flex flex-col gap-4 my-2 px-2 max-h-[200px] laptop:max-h-[540px]"
        >
          <div className="flex flex-col gap-3">
            <SurveyDetail
              name="Submission date:"
              value={
                survey.createdAt ? moment(survey.createdAt).format('DD.MM.YYYY, HH:mm') : 'n/a'
              }
            />
            <SurveyDetail
              name="From:"
              value={
                survey.from === 'parent'
                  ? `${enrollment?.user?.parentData?.fullName ?? ''} (Parent)`
                  : `${enrollment?.user?.fullName ?? ''}'
                    } (Student)`
              }
            />

            {survey.questions.map((q, i) => (
              <SurveyDetail key={i} name={q.question} value={String(q.answer)} />
            ))}
          </div>
        </Accordion>
      ))}
    </div>
  );
};

export default SurveyAccordion;
